import {
  List,
  Paper,
  Tabs as TabsMaterialUI,
  AppBar as AppBarMaterialUI,
  CircularProgress,
} from "@material-ui/core";
import { RiShareForward2Fill, RiCloseCircleLine } from "react-icons/ri";
import styled from "styled-components";

export const Container = styled(Paper)`
  padding-top: 10px;
  width: 375px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.06);
  border-radius: 10px 10px 0px 0px;
  display: flex;
  flex-direction: column;
`;

export const SearchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  width: 375px;
`;

export const FilterActive = styled.div`
  text-align: center;
  width: 100%;
  margin-bottom: 28px;
`;

export const FilterActiveText = styled.strong``;

export const LoadingContainer = styled.div`
  display: flex;
  width: 100%;
  height: 44px;
  align-items: center;
  justify-content: center;
`;

export const Loading = styled(CircularProgress)`
  width: 12px;
  height: 12px;
`;

export const Header = styled.div`
  margin-bottom: 10px;
`;

export const ForwardModeContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  height: 240px;
`;

export const ForwardSelectedCounter = styled.p`
  font-size: 14px;
  text-transform: uppercase;
`;

export const ForwardUnselectButton = styled.button`
  height: 52px;
  width: 320px;
  border: 1px solid #ef6573;
  border-radius: 5px;
  background: transparent;

  text-transform: uppercase;
  font-size: 13px;
  color: #ef6573;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  transition: background-color 0.2s linear;

  &:hover {
    background-color: #ef6573;
    color: #fff;
  }
`;

export const UnselectIcon = styled(RiCloseCircleLine)`
  color: inherit;
  font-size: 18px;
  margin-right: 10px;
`;

export const ForwardButton = styled.button`
  height: 52px;
  width: 320px;
  border: 1px solid #50b981;
  border-radius: 5px;
  background-color: #50b981;

  text-transform: uppercase;
  font-size: 13px;
  color: #ffff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: filter 0.3s;
  cursor: pointer;

  &:hover {
    filter: contrast(130%);
  }
`;

export const ForwardIcon = styled(RiShareForward2Fill)`
  color: #fff;
  font-size: 18px;
  margin-right: 10px;
`;

export const AppBar = styled(AppBarMaterialUI)`
  background-color: #fff;
  border: none;
  box-shadow: none;
  margin-bottom: 8px;
  z-index: 4;
`;

export const Content = styled(List)`
  list-style-type: none;
  height: 100%;
  position: relative;
  overflow: auto;
  overflow-x: hidden;
  padding: 0px;
  margin: 0px;

  ::-webkit-scrollbar {
    width: 5px;
    background: none;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #393e41;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: var(--primary);
  }

  .MuiButtonBase-root.MuiListItem-root.MuiListItem-gutters.MuiListItem-button {
    padding: 0px 0px 5px 10px;

    :hover {
      background-color: #fff;
    }
  }

  .current-contact {
    height: 92px;
    border-left: 4px solid var(--primary);
  }
`;

export const FavoriteContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const Tabs = styled(TabsMaterialUI)`
  margin-left: 10px;
  margin-right: 10px;

  .MuiTab-root {
    font-size: 8px;
    padding: 10px;
    margin: 0;
    min-width: 20%;
    width: 20%;
    color: #393e41;
  }

  div > span:last-child {
    background: #3d9be9;
    height: 4px;
  }

  .MuiBadge-badge {
    background-color: var(--primary);
    color: #fff;
  }
`;

export const Label = styled.div``;

export const TabTitle = styled.span`
  font-size: 9px;
`;

export const TabCounter = styled.p`
  font-size: 9px;
  letter-spacing: 0.8px;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  margin: 0px;
  padding: 0px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.05);

  font-size: 16px;
  line-height: 19px;
`;

export const Sentinel = styled(CircularProgress).attrs({
  size: 22,
})``;

export const LoadingMore = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 100%;
`;
